export const base64ToDataUrl = (base64String: string, format: string = 'image/png'): string =>
    `data:${format};base64,${base64String}`;
